import React, { useEffect, useState } from "react";

/**
 * Splash screen shown on app entry.
 * White background with the Finu logo centered.
 * Works on both desktop and mobile (full viewport, responsive logo size).
 *
 * Animations (CSS transitions, no Tailwind config needed):
 *  - Entrance: logo gently fades + scales in.
 *  - Exit: when `fadeOut` is true the whole overlay fades out and the
 *    logo lifts/scales slightly for a smooth, professional hand-off to Home.
 */
const SplashScreen = ({ fadeOut = false }) => {
  // Drive the entrance animation on the first paint.
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      className="fixed inset-0 z-[9999] bg-white"
      style={{
        opacity: fadeOut ? 0 : 1,
        transition: "opacity 500ms ease-in-out",
        willChange: "opacity",
      }}
    >
      {/* Center within the SAFE AREA, not the raw container. On PWA the splash
          area is asymmetric — its top sits under the status bar/notch while its
          bottom runs under the home indicator — so centering in the full
          container pushes the logo below the visual middle. Insetting by the
          safe-area envs centers it in the truly usable area. In a normal browser
          these envs are 0, so behaviour is unchanged there. */}
      <div
        className="absolute flex items-center justify-center"
        style={{
          top: "env(safe-area-inset-top, 0px)",
          bottom: "env(safe-area-inset-bottom, 0px)",
          left: "env(safe-area-inset-left, 0px)",
          right: "env(safe-area-inset-right, 0px)",
        }}
      >
        <img
          src="/finu-main-logo.svg"
          alt="Finu"
          className="w-[117px] sm:w-[146px] h-auto"
          style={{
            opacity: entered && !fadeOut ? 1 : 0,
            transform: `scale(${fadeOut ? 1.08 : entered ? 1 : 0.92})`,
            transition:
              "opacity 600ms ease-out, transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
            willChange: "opacity, transform",
          }}
        />
      </div>
    </div>
  );
};

export default SplashScreen;
